// extracted by mini-css-extract-plugin
export default {"root":"password-check_root__bTVCe","item":"password-check_item__89TRX","success":"password-check_success__Hn-oB","checkbox":"password-check_checkbox__CT28f"};